import React, { Component } from "react";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";

export interface IJOPContext {
	property?: AssetCard;

	setProperty( property: AssetCard ): void;
}

const defaultContext: IJOPContext = {
	property: undefined,
	setProperty: ( _p ) => {
	}
};
export const JOPContext = React.createContext( defaultContext );

interface Props {

}

interface State {
	property?: AssetCard;
}

class JOPContextWrapper extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {};
	}

	setProperty = ( p: AssetCard ) => {
		this.setState( { property: p } );
	};

	render() {
		const { children } = this.props;
		const { property } = this.state;
		return <JOPContext.Provider
			value={ { property: property, setProperty: this.setProperty } }>
			{ children }
		</JOPContext.Provider>;
	}
}

export default JOPContextWrapper;
